import {Heading, VStack} from 'platform/foundation';

import i18n from '@dms/i18n';

import {GearboxOilReplacementGroup} from '../../kit/groups/GearboxOilReplacementGroup';
import {VehicleForm as VFKit} from '../../kit/VehicleForm';

export function GearboxOilReplacementSubSection() {
  return (
    <>
      <VFKit.SubSection data-testid="gearbox-oil-replacement">
        <VStack spacing={4}>
          <Heading size={4}>{i18n.t('entity.vehicle.labels.gearboxOil')}</Heading>
          <VFKit.Group columns={4} data-testid="gearbox-oil-replacement-group">
            <GearboxOilReplacementGroup />
          </VFKit.Group>
        </VStack>
      </VFKit.SubSection>
    </>
  );
}
